/**
 * @deprecated Only works inside schema form
 */
export function NoField() {
  return <div key="n/a"></div>
}

export default NoField
